<div class="modal-header"><h2 class="modal-title">Contact Information</h2></div>
<div class="modal-body">
    <dx-form *ngIf="contactLog" [formData]="contactLog" validationGroup="mainValidationGroup">
        <dxi-item dataField="noteDate" editorType="dxDateBox" [label]="{ text: 'Date' }" [editorOptions]="{ type: 'datetime', interval: 15, width: '250px' }" [disabled]="false">
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Comm. Method' }">
            <div *dxTemplate>
                <dx-select-box [(value)]="contactLog.contactMethodId" [items]="contactMethods" valueExpr="id" displayExpr="name" searchEnabled="true" searchMode="startswith">
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Type' }">
            <div *dxTemplate>
                <dx-select-box
                    [(value)]="contactLog.contactTypeId"
                    [items]="contactTypes"
                    valueExpr="id"
                    displayExpr="name"
                    searchEnabled="true"
                    searchMode="startswith"
                    (onValueChanged)="typeSelectionChanged($event)"
                >
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item *ngIf="contactLog.contactTypeId == 2" [label]="{ text: 'Dealer' }">
            <div *dxTemplate>
                <dx-select-box [(value)]="contactLog.dealerId" [items]="dealers" valueExpr="id" displayExpr="displayName" searchEnabled="true" searchMode="startswith">
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item *ngIf="contactLog.contactTypeId == 3" [label]="{ text: 'Vendor' }">
            <div *dxTemplate>
                <dx-select-box [(value)]="contactLog.vendorId" [items]="vendors" valueExpr="id" displayExpr="companyName" searchEnabled="true" searchMode="startswith">
                </dx-select-box>
            </div>
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item *ngIf="contactLog.contactTypeId == 1 || contactLog.contactTypeId == 4" dataField="companyName" [label]="{ text: 'Company' }"> </dxi-item>
        <dxi-item dataField="contactName" [label]="{ text: 'Name' }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="phoneNumber" [label]="{ text: 'Phone #' }"> </dxi-item>
        <dxi-item dataField="email"> </dxi-item>

        <dxi-item [label]="{ text: 'Reason' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="contactLog.reason" [height]="150"> </dx-text-area>
            </div>
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Resolution' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="contactLog.resolution" [height]="150"> </dx-text-area>
            </div>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button class="btn btn-secondary me-auto" (click)="partLookup()">Part Lookup</button>
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-default" (click)="close()">Cancel</button>
</div>
